export default "__VITE_ASSET__7f2308d2__"